<template>
    <div class="double-bar-chart" :style="`height:${getHeight()}px`">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/lib/echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/dataZoom";
import { BarChart } from "echarts/charts";
import log2 from "../../../../../../utils/log2";
import _ from "lodash";

echarts.use([BarChart]);

Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=watermark

const log = log2("DoubleBarChart");
export default Vue.extend({
    name: "DoubleBarChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Chart Title",
        },
        subTitle: {
            type: String,
            default: "",
        },

        xAxisData: {
            type: Object,
        },
        yAxisData: {
            type: Object,
        },
        series: {
            type: Array,
            default: () => [],
        },
        colorPalette: {
            type: Array,
        },
        overrideOptions: {
            type: Object,
            default: () => ({}),
        },
        autoHeight: {
            type: Boolean,
            default: true,
        },
        height: {
            type: Number,
            default: 300,
        },
    },
    methods: {
        getHeight() {
            return this.autoHeight ? Math.max(300, this.series[0]?.data?.length * 31 + 200) : this.height;
        },
        getOptions() {
            const colors = this.colorPalette
                ? this.colorPalette
                : [
                      ["#008080", "#00CDCD"],
                      ["#800080", "#FF4500"],
                      ["#FFC0CB", "#00BFFF"],
                      ["#FFFF00", "#00FF00"],
                      ["#D3D3D3", "#000080"],
                      ["#FF0000", "#000000"],
                      ["#FFA500", "#FFFF00"],
                      ["#800080", "#E6E6FA"],
                      ["#006400", "#8B4513"],
                      ["#0000FF", "#000080"],
                  ];
            let options = {
                color: colors.map((color) => ({
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: [
                        {
                            offset: 0,
                            color: color[0],
                        },
                        {
                            offset: 1,
                            color: color[1],
                        },
                    ],
                    global: false, // default is false
                })),
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        dataZoom: {
                            yAxisIndex: "none",
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ["line", "bar"] },
                        restore: {},
                        saveAsImage: {},
                    },
                },
                title: [
                    {
                        text: this.title,
                        subtext: this.subTitle,
                        left: "24%",
                        textAlign: "center",
                    },
                ],
                grid: {
                    top: 50,
                    width: "100%",
                    height: "auto",
                    left: 30,
                    containLabel: true,
                },
                xAxis: this.xAxisData,
                yAxis: this.yAxisData,

                series: this.series,
            };
            options = _.merge(options, this.overrideOptions || {});
            log("options", options);
            return options;
        },
    },
});
</script>

<style scoped lang="scss">
.double-bar-chart {
    width: 100%;
    height: 300px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
